import * as service from './service'
import Toast from 'antd-mobile/es/toast'

export default {
  namespace: 'widgetMallRecordList',
  state: {
    orderDataList: []
  },
  effects: {
    * getOrderList ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getOrderList, payload)
        const { data } = res
        if (data.status === 200) {
          yield put({ type: 'save', payload: { orderDataList: data.data } })
          return data
        } else {
          Toast.info(data.err || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        Toast.info('发生网络错误')
      }
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
